import { ActionContext } from "vuex";
import decoinUseCase from "../../../../domain/usecase/impl/decoin/decoinUseCase";
import JSConfetti from "js-confetti";
import { DecoinLimit } from "../../../../domain/entities/decoins";

class DecoinsState {
  dailyDecoinLimit = false;
  acceptDailyDecoinLimitMessage = false;
  isVisibleDecoinsModalLimit = false;
}

const state = new DecoinsState();

const mutations = {
  SET_DAILY_DECOIN_LIMIT(state: DecoinsState, dailyDecoinLimit: boolean): void {
    state.dailyDecoinLimit = dailyDecoinLimit;
  },
  SET_VISIBILITY_DECOINS_LIMIT_MODAL(
    state: DecoinsState,
    isVisible: boolean
  ): void {
    state.isVisibleDecoinsModalLimit = isVisible;
  },
  SET_ACCEPT_DAILY_DECOIN_LIMIT_MESSAGE(
    state: DecoinsState,
    acceptDailyDecoinLimitMessage: boolean
  ): void {
    state.acceptDailyDecoinLimitMessage = acceptDailyDecoinLimitMessage;
  }
};

const actions = {
  async dailyDecoinLimit({
    commit
  }: ActionContext<DecoinsState, DecoinsState>): Promise<void> {
    const response: DecoinLimit = await decoinUseCase.dailyDecoinLimit();
    commit("SET_DAILY_DECOIN_LIMIT", response.isDecoinLimitExceed);
    commit(
      "SET_ACCEPT_DAILY_DECOIN_LIMIT_MESSAGE",
      response.acceptDailyDecoinLimitMessage
    );
  },
  async setDecoinsLimitModal(
    { commit }: ActionContext<DecoinsState, DecoinsState>,
    isVisible: boolean
  ): Promise<void> {
    console.log("chamou");
    if (state.acceptDailyDecoinLimitMessage) return;
    commit("SET_VISIBILITY_DECOINS_LIMIT_MODAL", isVisible);
    if (state.isVisibleDecoinsModalLimit) {
      const jsConfetti = new JSConfetti();
      await jsConfetti.addConfetti();
    }
  },
  async decoinDailyLimitMessageAccepted({
    commit
  }: ActionContext<DecoinsState, DecoinsState>): Promise<void> {
    return await decoinUseCase.decoinDailyLimitMessageAccepted();
  }
};

const getters = {
  dailyDecoinLimit: (state: DecoinsState): boolean => state.dailyDecoinLimit,
  acceptDailyDecoinLimitMessage: (state: DecoinsState): boolean =>
    state.acceptDailyDecoinLimitMessage,
  isVisibleDecoinsModalLimit: (state: DecoinsState): boolean =>
    state.isVisibleDecoinsModalLimit
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
